import { Box, IBoxProps } from '@/src/packages/components/ui/Box';
import { Heading } from '@/src/packages/components/ui/Heading';
import { cn } from '@/src/packages/utils/cn';
import { ReactNode } from 'react';

export const PanelTitle = ({ children }: { children: ReactNode }) => {
  return (
    <Heading as="h2" fontWeight="medium">
      {children}
    </Heading>
  );
};

export const PanelHeader = (props: IBoxProps) => {
  return (
    <Box
      as="header"
      className="h-16"
      paddingX={6}
      display="flex"
      alignItems="center"
      {...props}
    />
  );
};

export const PanelBody = (props: IBoxProps) => {
  return <Box as="main" padding={6} paddingTop={0} {...props} />;
};

export const Panel = (props: IBoxProps) => {
  const { className, ...rest } = props;

  return <Box className={cn('bg-background-secondary', className)} {...rest} />;
};
